import ServicePlanPricingPoliciesTable from 'src/features/servicePlanPricingPolicies/components/tables/ServicePlanPricingPoliciesTable';
import { useServicePlanItemTabContext } from 'src/features/servicePlanItems/utils/tabContext';

/** Pricing policies tab; takes the item's active flag from the outlet context. */
const ServicePlanPricingPoliciesTab = () => {
    const { isServicePlanItemActive } = useServicePlanItemTabContext();

    return <ServicePlanPricingPoliciesTable isServicePlanItemActive={isServicePlanItemActive} />;
};

export default ServicePlanPricingPoliciesTab;
